const idTranslation = {
  common: {
    close: 'Tutup',
    flagCaution: 'Topik sensitif. Periksa kembali jawaban ini dengan teliti.',
    flagInfo: 'Sekadar informasi.',
    welcome: 'Selamat datang',
    login: 'Masuk',
    logout: 'Keluar',
    send: 'Kirim',
    stop: 'Berhenti',
    retry: 'Coba lagi',
    loading: 'Memuat...',
    error: 'Kesalahan',
    success: 'Berhasil',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    typeToFilter: 'Ketik untuk memfilter…',
    save: 'Simpan',
    language: 'Bahasa',
    newChat: 'Percakapan baru',
    startingNewChat: 'Memulai percakapan baru...',
    searchMessage: 'Berpikir dan menganalisis informasi yang relevan...',
    searchMessageTiming: 'Mencari melalui instruksi kerja dan item pengetahuan...',
    tryAgain: 'Coba Lagi',
    back: 'Kembali',
    enabled: 'Aktif',
    disabled: 'Nonaktif',
    goBack: 'Kembali',
    attachDocument: 'Lampirkan dokumen',
    aiDisclaimer:
      'Jawaban dihasilkan oleh AI. Selalu verifikasi informasi penting melalui sumber resmi.',
    copyAnswer: 'Salin jawaban',
    copyMessage: 'Salin pesan',
    copied: 'Tersalin!',
    copyToClipboard: 'Salin ke papan klip',
    expand: 'Perluas',
    minimize: 'Perkecil',
    showMore: 'Tampilkan lebih banyak',
    noInternalKnowledge: 'Tidak ada pengetahuan internal yang ditemukan',
    noAdditionalResponse: 'Tidak ada respons tambahan',
    swapMessage:
      'Kami menemukan jawaban khusus perusahaan. Jawaban umum tetap tersedia di bawah ini.',
    toggleShowGeneral: 'Tampilkan jawaban umum (ChatGPT)',
    toggleHideGeneral: 'Sembunyikan jawaban umum',
    progressExternal: 'Mencari dengan ChatGPT…',
    progressInternal: 'Mencari pengetahuan perusahaan…',
    internalError: 'Pengetahuan perusahaan tidak tersedia saat ini.',
    promoteSecondary: 'Gunakan sebagai jawaban utama',
    compareAnswers: 'Bandingkan jawaban secara berdampingan',
    switchBack: 'Kembali',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Pedoman internal',
  },
  // Retrieval-step labels, keyed by graph tool prefix. A per-source key
  // (`tools.graph_search_<key>.done`) overrides these when one is defined.
  tools: {
    graph_search: {
      active: 'Mencari di knowledge graph…',
      done: 'Knowledge graph selesai dicari',
    },
    ask_clarification: {
      active: 'Menyusun pertanyaan klarifikasi…',
      done: 'Pertanyaan klarifikasi diajukan',
    },
    unknown: {
      active: '{{name}} berjalan…',
      done: '{{name}} selesai',
    },
    statusDone: 'Selesai',
    statusRunning: 'Berjalan…',
  },
  clarification: {
    escapeHatchLabel: 'Ketik jawaban saya sendiri',
    skip: 'Lewati',
    submit: 'Kirim',
    nextQuestion: 'Pertanyaan berikutnya',
    previousQuestion: 'Pertanyaan sebelumnya',
    selectAllThatApply: '(Pilih semua yang sesuai)',
    stepCounter: '{{current}} dari {{total}}',
    selectedCount: '{{count}} dipilih',
    selectOption: 'Pilih {{label}}',
    deselectOption: 'Batalkan pilihan {{label}}',
    shortcutHint: '↑↓ navigasi · Enter pilih · Shift+Enter kirim · Esc lewati',
  },
  knowledge_source: {
    badge_ai: 'AI',
    badge_internal: 'Data perusahaan',
    badge_internet: 'Internet',
  },
  errors: {
    assistantResponseContentViolation:
      'Respons asisten melanggar kebijakan konten kami. Silakan coba lagi atau ubah pertanyaan Anda.',
    userInputContentViolation:
      'Permintaan Anda berisi konten yang melanggar kebijakan konten kami. Silakan ubah pertanyaan Anda.',
    llmProviderUserInputBlocked:
      'Pesan Anda diblokir oleh filter konten penyedia AI. Silakan ubah pertanyaan Anda.',
    llmProviderBotResponseBlocked:
      'Respons AI diblokir oleh filter konten penyedia. Silakan coba lagi atau ubah pertanyaan Anda.',
    llmProviderApiError: 'Kami mengalami masalah dengan layanan AI kami. Silakan coba lagi nanti.',
    modelRateLimited:
      'Model AI sedang sibuk saat ini. Silakan coba lagi — jika masih sibuk, model lain akan menjawab.',
    modelTimeout: 'Model AI terlalu lama menjawab. Silakan coba lagi.',
    modelUnavailable:
      'Model AI sedang tidak tersedia. Silakan coba lagi — model lain akan menjawab.',
    serverError:
      'Terjadi kesalahan server yang tidak terduga. Silakan coba lagi atau hubungi dukungan jika masalah berlanjut.',
    agentNotFound: 'Asisten yang Anda cari tidak ada atau tidak lagi tersedia.',
    conversationNotFound: 'Percakapan yang Anda cari tidak ada atau tidak lagi tersedia.',
    noAccessScopes:
      'Saat ini Anda tidak memiliki akses ke sumber pengetahuan apa pun. Untuk meminta akses, silakan buat tiket dukungan atau hubungi administrator IT Anda.',
    noAccessScopesWithEmail:
      'Saat ini Anda tidak memiliki akses ke sumber pengetahuan apa pun. Untuk meminta akses, silakan buat tiket dukungan atau hubungi dukungan IT di {{email}}.',
    startViolatedPoliciesList: 'Kebijakan berikut telah dilanggar',
    questionTooLong: {
      title: 'Pertanyaan Anda terlalu panjang',
      description: 'Panjang maksimum adalah 30.000 karakter.',
    },
    excelNotSupportedYet: {
      title: 'Dukungan Excel dan CSV segera hadir!',
      description:
        'Kami sedang mengerjakan dukungan untuk file Excel dan CSV dan akan tersedia segera. Untuk saat ini, silakan gunakan file PDF atau Word.',
    },
    internetSearchNotWaiting: 'Pencarian ini sudah dijawab, misalnya di tab lain. Muat ulang halaman untuk melihat hasilnya.',
  },
  auth: {
    welcomeTester: 'Selamat datang rekan',
    welcomeMessage: 'Selamat datang di {{assistantName}}!',
    loginWithMicrosoft: 'Masuk dengan Microsoft',
    loginInstructions: 'Masuk dengan akun Microsoft Anda untuk memulai.',
    welcomeCompany: 'Selamat datang di {{companyName}}!',
    loginWithPassword: 'Masuk dengan nama pengguna dan kata sandi',
    hidePasswordForm: 'Sembunyikan',
    login: 'Masuk',
  },
  chat: {
    placeholder: 'Ajukan pertanyaan Anda di sini',
    thinking: 'Sedang berpikir...',
    anonymousUser: 'Anonim',
    howToAskGoodQuestion: 'Bagaimana cara mengajukan pertanyaan yang baik?',
    askQuestion: 'Ajukan pertanyaan Anda',
    exampleQuestions: 'Contoh pertanyaan',
    tryAsking: 'Coba tanyakan:',
    assistant: '{{assistantName}}, asisten digital Anda',
    welcomeMessage:
      'Halo {{name}}! Saya {{assistantName}}, asisten digital Anda. Saya dapat membantu Anda dengan pertanyaan tentang instruksi kerja dan item pengetahuan. Apa yang ingin Anda ketahui?',
    loading: 'Memuat percakapan...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    serverError:
      'Terjadi kesalahan server yang tidak terduga. Silakan coba lagi atau hubungi dukungan jika masalah berlanjut.',
    disclaimerText:
      'Jawaban yang dihasilkan oleh AI. Tidak ada hak yang dapat diperoleh dari jawaban ini.',
    dropFilesHere: 'Letakkan file di sini untuk ditambahkan ke obrolan',
    addMenu: 'Tambah',
    addFiles: 'Tambah file',
    knowledgeSourceOff: '{{name}} nonaktif',
    filteredTo: 'Difilter ke',
    talkingTo: 'Berbicara dengan {{name}}',
    leaveAgent: 'Tinggalkan {{name}}',
    askAgain: 'Tanya asisten lain',
    askAgent: 'Tanya {{name}}',
    filters: 'Filter',
    filtersInfo: 'Membatasi obrolan ke filter tertentu.',
    unsupportedFileType: 'Jenis file tidak didukung',
    uploadingFile: 'Mengunggah file…',
    uploadLimit: 'Hingga {{max}} file, masing-masing maksimal 10 MB',
    fileTooLarge: 'Ukuran file harus kurang dari 10 MB',
    fileTypeNotAllowed: 'Hanya file PDF, Word, Excel, PowerPoint (PPTX), CSV, dan TXT yang diperbolehkan',
    fileTypeNotAllowedWithImages:
      'Hanya file PDF, Word, Excel, PowerPoint (PPTX), CSV, TXT, dan gambar (PNG, JPEG, WEBP) yang diperbolehkan',
    documentUploadFailed: 'Gagal mengunggah dokumen',
    tooManyFiles: 'Anda dapat melampirkan hingga {{max}} file per pesan',
    attachmentsNotReady: 'Tunggu hingga semua file selesai diunggah, atau hapus file yang gagal',
    retryAttachment: 'Unggah ulang {{name}}',
    removeAttachment: 'Hapus {{name}}',
  },
  answerStatus: {
    checking: 'Memeriksa kueri pencarian…',
    internet: 'Mencari di internet: {{query}}',
    knowledge: 'Mencari data perusahaan: {{query}}',
    document: 'Membaca dokumen Anda…',
    files_other: 'Memproses {{count}} berkas…',
    image: 'Melihat gambar…',
    imageNamed: 'Melihat gambar: {{name}}',
    slowFiles: 'Berkas besar dengan banyak gambar bisa memakan waktu beberapa menit…',
  },
  internetSearch: {
    badgeLabel: 'Pencarian internet',
    queriesSent_other: '{{count}} kueri pencarian dikirim',
    badgeTooltip: 'Asisten ini dapat mencari di internet',
    approval: {
      queryTooLong: 'Persingkat kueri pencarian menjadi maksimal 500 karakter.',
      title: 'Izinkan pencarian internet?',
      descriptionOne: 'Kueri pencarian ini dikirim ke internet dan mungkin berisi data rahasia (disorot). Ubah atau kirim apa adanya.',
      descriptionMany: 'Kueri-kueri pencarian ini dikirim ke internet dan mungkin berisi data rahasia (disorot). Ubah atau kirim apa adanya.',
      descriptionUncheckedOne: 'Kueri pencarian ini dikirim ke internet. Kami tidak dapat memeriksanya secara otomatis: tinjau sendiri sebelum mengirimnya.',
      descriptionUncheckedMany: 'Kueri-kueri pencarian ini dikirim ke internet. Kami tidak dapat memeriksanya secara otomatis: tinjau sendiri sebelum mengirimnya.',
      descriptionCleanOne: 'Kueri pencarian ini dikirim ke internet. Tinjau dulu: ubah atau kirim apa adanya.',
      descriptionCleanMany: 'Kueri-kueri pencarian ini dikirim ke internet. Tinjau dulu: ubah atau kirim apa adanya.',
      queryLabel: 'Kueri pencarian',
      dropQuery: 'Jangan cari',
      dropped: 'Tidak akan dicari',
      undrop: 'Tetap cari',
      sendSearch: 'Kirim pencarian',
      useInternal: 'Gunakan data internal',
      continueWithoutInternet: 'Lanjutkan tanpa internet',
      internalStatus: 'Pencarian internet dilewati · Menggunakan data internal',
      noInternetStatus: 'Pencarian internet dilewati · Menjawab tanpa internet',
      categories: {
        customer: 'nama pelanggan',
        person: 'orang',
        vessel: 'kapal',
        project: 'proyek',
        internal_code: 'kode internal',
        contact: 'detail kontak',
        financial: 'keuangan',
        credential: 'kredensial login',
        identifier: 'nomor identitas',
        special_category: 'data pribadi sensitif',
        confidential: 'rahasia',
        other: 'mungkin rahasia',
      },
    },
  },
  agentChat: {
    placeholder: 'Ketik pertanyaan Anda untuk agen...',
    welcomeMessage: 'Halo, saya agen AI Anda. Bagaimana saya bisa membantu Anda hari ini?',
    privilegedWelcomeMessage: 'Halo {{userName}}! {{description}}',
    startPrompt: 'Ajukan pertanyaan untuk memulai',
  },
  profile: {
    settings: 'Pengaturan',
    selectLanguage: 'Pilih bahasa Anda',
    appearance: 'Tampilan',
    darkMode: 'Mode Gelap',
    languageChanged: 'Bahasa diubah',
    noEmailAvailable: 'Tidak ada email tersedia',
    general: 'Umum',
    models: 'Model',
    noModelsAvailable: 'Tidak ada model tersedia',
    modelSettings: 'Pengaturan model',
    savingSettings: 'Menyimpan...',
    settingsUpdateFailed: 'Gagal menyimpan pengaturan model. Silakan coba lagi.',
  },
  sidebar: {
    conversations: 'Riwayat',
    assistants: 'Asisten',
    userGuide: 'Panduan pengguna',
    chatHistory: 'Riwayat percakapan',
    today: 'Hari ini',
    thisWeek: 'Minggu ini',
    lastWeek: 'Minggu lalu',
    earlier: 'Lebih awal',
    conversation: 'Percakapan',
    noAssistantsAvailable: 'Tidak ada asisten tersedia',
    noContent: 'Tidak ada konten',
    noPreviousConversations: 'Tidak ada riwayat sebelumnya yang ditemukan',
    searchConversations: 'Cari riwayat...',
    noSearchResults: 'Tidak ada riwayat yang cocok dengan pencarian Anda',
    favorites: 'Favorit',
    noFavorites: 'Tidak ada favorit',
    addFavoritesHint: 'Buka pustaka untuk menambahkan asisten ke favorit Anda.',
    loadingPrivilegedAgents: 'Memuat asisten...',
    rename: 'Ganti nama',
    conversationActions: 'Tindakan percakapan',
    renameConversationError: 'Gagal mengganti nama percakapan',
  },
  feedback: {
    likeAnswer: 'Suka jawaban',
    dislikeAnswer: 'Tidak suka jawaban',
    feedbackSent: 'Masukan Anda telah dikirim! ✅',
    provideFeedback: 'Berikan masukan tentang pertanyaan',
    enterFeedback: 'Masukkan masukan Anda di sini',
    send: 'Kirim',
    assistantFallback: 'asisten AI',
    downvoteDisclaimer:
      'Saat Anda menekan kirim, dua pesan terakhir Anda akan dibagikan secara anonim untuk dianalisis guna membantu meningkatkan {{assistant}}.',
    reasons: {
      incorrect: 'Jawaban tidak benar',
      sourceIncorrect: 'Sumber tidak benar',
      other: 'Lainnya...',
    },
  },
  // Generic information pop-out — client-agnostic.
  // Texts are feature-flag driven and use {{companyName}} for the company name.
  informationModal: {
    title: 'Tentang asisten {{companyName}}',
    intro:
      'Selamat datang di asisten {{companyName}}. Di bawah ini Anda akan menemukan apa yang dapat dibantu oleh asisten dan cara memanfaatkannya secara maksimal.',
    capabilitiesTitle: 'Apa yang dapat dibantu oleh asisten?',
    activeVanillaChat:
      'Asisten dapat menjawab pertanyaan seperti yang akan Anda ajukan ke ChatGPT.',
    activeVanillaInactiveWebSearch:
      'Asisten memiliki pengetahuan umum yang luas, tetapi tidak mengetahui peristiwa terkini seperti berita terbaru.',
    activeInternalSearch:
      'Asisten dapat menjawab pertanyaan berdasarkan pilihan khusus dari sumber informasi internal.',
    activeInternetSearch:
      'Asisten dapat mencari di internet untuk menjawab pertanyaan tentang peristiwa terkini.',
    activeInternetSearchPrivacyWarning:
      'Catatan: pertanyaan dan jawaban dari pencarian internet, seperti penggunaan internet biasa, tidak sepenuhnya bersifat pribadi. Jangan bagikan informasi rahasia perusahaan saat menggunakan pencarian web.',
    activeDocumentUpload:
      'Anda dapat mengunggah dokumen dan mendiskusikannya dengan asisten, misalnya untuk meringkasnya atau mengekstrak poin-poin tindakan.',
    activeAgents:
      'Anda dapat memilih <1>asisten</1> tertentu untuk diajak bicara. Setiap asisten memiliki instruksinya sendiri sehingga lebih baik dalam tugas-tugas tertentu.',
    activeModelSelection:
      'Di kolom masukan pesan, Anda memilih model AI mana yang menjawab pertanyaan Anda. Di <1>halaman pengaturan model</1>, Anda dapat menyesuaikan pengaturan setiap model untuk mengontrol cara responsnya.',
    usageTipsTitle: 'Cara memanfaatkan asisten secara maksimal',
    askClearQuestions:
      'Ajukan pertanyaan yang jelas dalam kalimat lengkap. Kata kunci tunggal sering menghasilkan jawaban yang biasa-biasa saja; kalimat lengkap memberi asisten konteks yang dibutuhkan untuk membantu Anda dengan baik.',
    conversationHistory:
      'Dalam satu percakapan, asisten mengingat apa yang Anda katakan sebelumnya, sehingga Anda dapat mengajukan pertanyaan lanjutan. Asisten tidak memahami maksud Anda jika Anda merujuk pada informasi dari percakapan lain.',
    startNewConversation:
      'Mulai percakapan baru (tombol di kiri atas) saat beralih ke topik yang berbeda, agar jawaban tetap tajam.',
    bewareAssistantsNotAgents:
      'Catatan: ini adalah asisten AI, bukan agen AI. Asisten membantu Anda dengan tugas individual saat Anda meminta, misalnya meringkas email, tetapi tidak secara mandiri mengambil tindakan lanjutan seperti mengirim email.',
    feedback:
      'Gunakan ikon jempol di bawah jawaban untuk memberikan masukan. Itu membantu membuat asisten lebih cerdas.',
    dataVisibilityNoticeTitle: 'Pemberitahuan visibilitas data',
    bewareDoNotSharePersonalInformation: 'Catatan: jangan bagikan informasi pribadi.',
    supportTitle: 'Butuh bantuan?',
  },
  library: {
    title: 'Pustaka Asisten',
    subtitle:
      'Temukan dan buat versi khusus asisten yang menggabungkan instruksi, pengetahuan tambahan, dan kombinasi keterampilan apa pun.',
    searchPlaceholder: 'Cari asisten...',
    createAgent: 'Buat Asisten',
    createFirstAgent: 'Buat asisten pertama Anda',
    noAgents: 'Tidak ada asisten tersedia',
    noSearchResults: 'Tidak ada asisten yang cocok dengan pencarian Anda',
    noDescription: 'Tidak ada deskripsi tersedia',
    mainChat: 'Percakapan utama',
    active: 'Aktif',
    library: 'Pustaka',
    of: 'dari',
    assistants: 'asisten',
    clearFilters: 'Hapus filter',
    filtersCleared: 'Filter dihapus',
    all: 'Semua',
    favorites: 'Favorit',
    normal: 'Normal',
    privileged: 'Istimewa',
    noTags: 'Tidak ada tag',
    agentSelected: 'Asisten dipilih',
    isNowActive: 'sekarang aktif',
    select: 'Pilih',
    addToFavorites: 'Tambahkan ke favorit',
    removeFromFavorites: 'Hapus dari favorit',
    moreTags: 'tag lainnya',
    editAgent: 'Edit asisten',
  },
  createAgent: {
    title: 'Asisten Baru',
    subtitle: 'Buat asisten AI baru untuk membantu tim Anda',
    saving: 'Menyimpan...',
    saveAgent: 'Simpan Asisten',
    basicInfo: 'Informasi Dasar',
    classification: 'Klasifikasi',
    tagsAndCustomization: 'Tag & Penyesuaian',
    icon: 'Ikon',
    name: 'Nama',
    namePlaceholder: 'Beri asisten sebuah nama',
    description: 'Deskripsi',
    descriptionPlaceholder: 'Jelaskan apa yang dapat dilakukan asisten',
    department: 'Departemen',
    selectDepartment: 'Pilih departemen',
    jobCategory: 'Kategori Pekerjaan',
    selectJobCategory: 'Pilih kategori pekerjaan',
    tags: 'Tag',
    optional: 'opsional',
    addNewTag: 'Tambahkan tag baru',
    add: 'Tambah',
    existingTags: 'Tag yang ada',
    promptTemplate: 'Templat Prompt',
    promptTemplatePlaceholder:
      'Tentukan bagaimana asisten harus merespons... (misalnya: Anda adalah asisten meja bantuan yang merespons dengan ramah dan profesional terhadap pertanyaan tentang...)',
    fillAllRequiredFields: 'Silakan isi semua kolom yang wajib diisi',
    agentCreated: 'Asisten dibuat',
    createdSuccessfully: 'berhasil dibuat',
    creationError: 'Kesalahan pembuatan',
    creationErrorDescription: 'Terjadi kesalahan saat membuat asisten',
    unsavedChanges: 'Perubahan belum disimpan',
    unsavedChangesMessage:
      'Anda telah membuat perubahan yang belum disimpan. Apakah Anda yakin ingin kembali?',
    manageJobCategories: 'Kelola kategori pekerjaan untuk departemen ini',
    instructions: 'Instruksi',
    instructionsDescription: 'Tentukan bagaimana asisten Anda harus berperilaku dan merespons pengguna',
    instructionsLabel: 'Instruksi',
    instructionsPlaceholder: 'Anda adalah asisten yang membantu yang...',
    instructionsHelperText: 'Jelaskan secara spesifik peran asisten, nada bicara, dan cara membantu pengguna',
    instructionsMinLength: 'Instruksi harus minimal 20 karakter',
    tools: 'Alat',
    searchTool: 'Alat pencarian',
    toolsFileSearch: 'Pencarian file',
    toolsImageInspection: 'Inspeksi gambar',
    toolsKnowledgeSearch: 'Cari di semua sumber pengetahuan',
    toolsGraphSearch: 'Cari di knowledge graph',
    toolsClarification: 'Ajukan pertanyaan klarifikasi',
    toolsKnowledgeSource: 'Cari {{name}}',
    toolsColumnName: 'Alat',
    toolsColumnEnabled: 'Diaktifkan',
    toolsColumnTraced: 'Dilacak',
    toolsTopK: 'Dokumen per pencarian',
    toolsTopKHelp: 'Berapa banyak dokumen yang dikembalikan oleh pencarian basis pengetahuan. Biarkan kosong untuk nilai bawaan (5). Nilai lebih tinggi mencakup lebih banyak, nilai lebih rendah menjaga jawaban tetap fokus.',
    toolsTracedHelp: "Ketika mode pelacakan asisten adalah 'Saat alat digunakan', menggunakan alat ini akan merekam percakapan secara anonim untuk tujuan analitis.",
    toolsInternetSearch: 'Pencarian internet',
    flags: 'Penanda',
    flagsHelp: 'Pilih penanda mana yang dapat ditampilkan asisten ini. Secara bawaan semuanya berlaku — matikan penanda yang tidak relevan dengan topiknya.',
    flagsColumnName: 'Penanda',
    flagsColumnSeverity: 'Tingkat',
    flagsColumnEnabled: 'Berlaku',
    flagsSeverityInfo: 'Info',
    flagsSeverityWarning: 'Peringatan',
    flagsSeverityCritical: 'Kritis',
    tracing: 'Pelacakan',
    tracingHelp: 'Kontrol apakah dan bagaimana perilaku internal agen ini dicatat untuk tujuan diagnostik. Menggantikan pengaturan berbasis alat',
    tracingAlways: 'Aktif',
    tracingNever: 'Nonaktif',
    tracingToolBased: 'Berbasis alat',
    visibility: 'Visibilitas',
    visibilityHelp: 'Kontrol siapa yang dapat melihat asisten ini. Asisten pribadi hanya terlihat oleh Anda.',
    visibilityPublic: 'Tampilkan ke entitas klien yang dipilih',
    visibilityEntities: 'Entitas klien',
    visibilityEntitiesPlaceholder: 'Pilih entitas klien',
    visibilityEntitiesHelp: 'Pengguna yang terkait dengan salah satu entitas ini dapat melihat asisten ini.',
    routing: 'Percakapan utama',
    routingHelp: 'Percakapan utama meneruskan pertanyaan yang cocok ke asisten ini. Router membaca deskripsi perutean dan contoh pertanyaan.',
    routingDescription: 'Deskripsi perutean',
    routingDescriptionPlaceholder: 'Gunakan untuk: …\nBukan untuk: …\nContoh: …',
    routingDescriptionHelp: 'Jelaskan untuk apa asisten ini dan, sama pentingnya, untuk apa tidak, terutama di bagian yang bersinggungan dengan asisten lain. Gunakan kata-kata yang benar-benar diketik orang, dalam bahasa mereka sendiri. {{count}}/{{max}} karakter.',
    routingDescriptionTooLong: 'Maksimal {{max}} karakter.',
    routingAvailable: 'Tersedia di percakapan utama',
    routingNotReady: 'Memerlukan deskripsi perutean dan minimal {{min}} contoh pertanyaan.',
    routingUseClientContext: 'Gunakan konteks perusahaan',
    routingUseClientContextHelp: 'Menempatkan konteks perusahaan (lokasi, produk, budaya) sebelum instruksi asisten ini sendiri. Instruksinya sendiri yang diutamakan.',
    featureRequest: 'Permintaan fitur',
    deleteAssistant: 'Hapus Asisten',
    tagsHelp: 'Tag membantu mengatur dan mengkategorikan asisten Anda',
    exampleQuestions: 'Contoh Pertanyaan',
    exampleQuestionsHelp: 'Tambahkan contoh pertanyaan yang dapat diklik pengguna untuk memulai percakapan',
  },
  editAgent: {
    title: 'Edit Asisten',
    subtitle: 'Ubah pengaturan dan perilaku asisten AI Anda',
    updateAgent: 'Perbarui Asisten',
    deleteAgent: 'Hapus Asisten',
    updating: 'Memperbarui...',
    deleting: 'Menghapus...',
    agentUpdated: 'Asisten Diperbarui',
    updatedSuccessfully: 'telah berhasil diperbarui',
    updateError: 'Kesalahan Pembaruan',
    updateErrorDescription: 'Terjadi kesalahan saat memperbarui asisten. Silakan coba lagi.',
    agentDeleted: 'Asisten Dihapus',
    deletedSuccessfully: 'telah berhasil dihapus',
    deleteError: 'Kesalahan Penghapusan',
    deleteErrorDescription: 'Terjadi kesalahan saat menghapus asisten. Silakan coba lagi.',
    deleteConfirmTitle: 'Hapus Asisten',
    deleteConfirmMessage:
      'Apakah Anda yakin ingin menghapus asisten ini? Tindakan ini tidak dapat dibatalkan.',
    confirmDelete: 'Ya, Hapus',
    loadingAgent: 'Memuat detail asisten...',
    failedToLoad: 'Gagal memuat detail asisten',
  },
  jobCategory: {
    addNew: 'Tambah Kategori',
    name: 'Nama',
    nameRequired: 'Nama kategori wajib diisi',
    enterName: 'Masukkan nama kategori...',
    create: 'Buat',
    edit: 'Edit',
    update: 'Perbarui',
    delete: 'Hapus',
    created: 'Kategori Dibuat',
    createdSuccessfully: 'berhasil dibuat',
    updated: 'Kategori Diperbarui',
    updatedSuccessfully: 'berhasil diperbarui',
    deleted: 'Kategori Dihapus',
    deletedSuccessfully: 'berhasil dihapus',
    creationError: 'Kesalahan Pembuatan',
    creationErrorDescription: 'Terjadi kesalahan saat membuat kategori',
    updateError: 'Kesalahan Pembaruan',
    updateErrorDescription: 'Terjadi kesalahan saat memperbarui kategori',
    deletionError: 'Kesalahan Penghapusan',
    deletionErrorDescription: 'Terjadi kesalahan saat menghapus kategori',
    deleteError: 'Kesalahan Penghapusan',
    deleteErrorDescription: 'Terjadi kesalahan saat menghapus kategori',
    deleteConfirmTitle: 'Hapus Kategori',
    deleteConfirmMessage: 'Apakah Anda yakin ingin menghapus "{{name}}"?',
    deleteWarning: 'Tindakan ini tidak dapat dibatalkan dan dapat memengaruhi agen yang ada.',
    warning: 'Peringatan',
    agentsWillLoseCategory: 'agen akan kehilangan penetapan kategorinya',
  },
  languageNames: {
    en: 'Inggris',
    nl: 'Belanda',
    de: 'Jerman',
    fr: 'Prancis',
    it: 'Italia',
    pl: 'Polandia',
    hu: 'Hungaria',
    id: 'Bahasa Indonesia',
  },
  knowledgeSourceSelector: {
    title: 'Sumber pengetahuan',
    tooltip: 'Pilih sumber pengetahuan mana yang akan dicari',
    all: 'Semua',
  },
  countries: {
    nl: 'Belanda',
    us: 'Amerika',
    hu: 'Hungaria',
    id: 'Indonesia',
  },
  iconSelector: {
    chooseIcon: 'Pilih ikon',
  },
  models: {
    optionUnavailable: '{{model}} — sementara tidak tersedia',
    modelRateLimited: '{{model}} sedang dibatasi sementara. Permintaan dialihkan ke model berikutnya yang tersedia.',
    modelUnavailable: '{{model}} saat ini tidak tersedia. Permintaan dialihkan ke model lain.',
    fallbackToast: 'Beralih ke {{fallbackModel}} — {{originalModel}} sementara tidak tersedia.',
    recommended: 'Direkomendasikan',
    verifySources: 'Jawaban ini berasal dari model yang kurang andal untuk pertanyaan HR. Silakan periksa ke sumbernya sebelum menindaklanjuti.',
    introHeading: 'Pengaturan model',
    introBody: 'Di halaman ini Anda mengatur bagaimana setiap model berperilaku. Model mana yang digunakan untuk sebuah percakapan tidak dipilih di sini, Anda memilihnya di obrolan itu sendiri, di samping kolom masukan tempat Anda mengetik pertanyaan.',
    noConfigurableParameters: 'Tidak ada pengaturan untuk model ini',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'Asisten AI untuk pengetahuan perusahaan dari AHV International.',
}

export default { ...idTranslation, ...clientDefaults }
